/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormData
 */
export interface FormData {
}

/**
 * Check if a given object implements the FormData interface.
 */
export function instanceOfFormData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormDataFromJSON(json: any): FormData {
    return FormDataFromJSONTyped(json, false);
}

export function FormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormData {
    return json;
}

export function FormDataToJSON(value?: FormData | null): any {
    return value;
}

